import { useIntl } from 'react-intl'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'

function PerfectForGroupsLabel() {
  const intl = useIntl()

  return (
    <StructureLabel
      variant="perfect-for-groups"
      startIcon={<LineUsersAltIcon />}
    >
      {intl.formatMessage({
        id: 'ipyD-wIT-JeGQztu1sor',
        defaultMessage: 'Perfect for groups',
        description: 'Label shown on Maldives group villa charter offers to highlight that the package is especially suitable for group travel.',
      })}
    </StructureLabel>
  )
}

export default PerfectForGroupsLabel
